export default __webpack_public_path__ + "static/media/ed2mit2020practice02-aws-emr-config-v02.885466c8.pdf";